var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "edit-catalog-modal",
            title: "Edit Flipbook",
            centered: "",
            "ok-title": "Save",
            "ok-disabled": !_vm.canSubmit || _vm.isSaving,
          },
          on: { show: _vm.populateForm, ok: _vm.accept },
        },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                label: "Name",
                "label-for": "edit-catalog-name-input",
                "invalid-feedback":
                  "Enter a name of at least 1 and less than 255 chars.",
                state: _vm.nameState,
              },
            },
            [
              _c("b-form-input", {
                attrs: {
                  id: "edit-catalog-name-input",
                  state: _vm.nameState,
                  required: "",
                  autofocus: "",
                  trim: "",
                },
                model: {
                  value: _vm.name,
                  callback: function ($$v) {
                    _vm.name = $$v
                  },
                  expression: "name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "brand-section mt-3" }, [
            _c("div", { staticClass: "brand-header" }, [
              _c("span", { staticClass: "brand-label" }, [_vm._v("Brand")]),
              _vm._v(" "),
              _c("label", { staticClass: "brand-default-check" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.setAsDefault,
                      expression: "setAsDefault",
                    },
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.setAsDefault)
                      ? _vm._i(_vm.setAsDefault, null) > -1
                      : _vm.setAsDefault,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.setAsDefault,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.setAsDefault = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.setAsDefault = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.setAsDefault = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Set as default")]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "brand-row" }, [
              _c("div", { staticClass: "logo-box" }, [
                !_vm.logoUrl
                  ? _c("span", [_vm._v("LOGO")])
                  : _c("img", {
                      attrs: { src: _vm.logoUrl, alt: "Logo preview" },
                    }),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "tb-action",
                  attrs: { type: "button" },
                  on: { click: _vm.triggerLogoFileInput },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "16",
                        height: "16",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("path", { attrs: { d: "M12 19V5" } }),
                      _vm._v(" "),
                      _c("path", { attrs: { d: "M5 12l7-7 7 7" } }),
                    ]
                  ),
                  _vm._v("\n          Upload\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "tb-action",
                  attrs: { type: "button" },
                  on: { click: _vm.openFileBrowser },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "16",
                        height: "16",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z",
                        },
                      }),
                    ]
                  ),
                  _vm._v("\n          File Browser\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.closePicker,
                      expression: "closePicker",
                    },
                  ],
                  staticClass: "brand-color-wrap",
                },
                [
                  _c("button", {
                    staticClass: "brand-color-swatch",
                    style: { backgroundColor: _vm.brandColor },
                    attrs: {
                      type: "button",
                      "aria-label": "Choose brand color",
                    },
                    on: {
                      click: function ($event) {
                        _vm.pickerOpen = !_vm.pickerOpen
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.pickerOpen
                    ? _c("ColorPickerPopover", {
                        staticClass: "brand-color-popover",
                        model: {
                          value: _vm.brandColor,
                          callback: function ($$v) {
                            _vm.brandColor = $$v
                          },
                          expression: "brandColor",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              ref: "logoFileInput",
              staticClass: "d-none",
              attrs: { type: "file", accept: "image/*" },
              on: { change: _vm.onLogoFileSelected },
            }),
          ]),
          _vm._v(" "),
          _c("b-form-group", { staticClass: "mt-3 catalog-cover-upload" }, [
            _c("input", {
              ref: "coverImageInput",
              staticClass: "d-none",
              attrs: { type: "file", accept: "image/*" },
              on: { change: _vm.onCoverImageChange },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "catalog-cover-upload__content d-flex align-items-center justify-content-between",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center catalog-cover-upload__status",
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass:
                          "text-primary catalog-cover-upload__icon-info",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "M20 3v4" } }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "M22 5h-4" } }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "M4 17v2" } }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "M5 18H3" } }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-sm" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.coverStatus) +
                          "\n          "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-link p-0 font-sm",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.coverImageInput.click()
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass:
                        "bi bi-upload mr-1 catalog-cover-upload__icon-upload",
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.hasCustomCover ? "Replace" : "Upload custom"
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-3", attrs: { role: "group" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between",
                },
                [
                  _c("label", { staticClass: "mb-0" }, [_vm._v("Password")]),
                  _vm._v(" "),
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "mr-3",
                      model: {
                        value: _vm.requirePassword,
                        callback: function ($$v) {
                          _vm.requirePassword = $$v
                        },
                        expression: "requirePassword",
                      },
                    },
                    [_vm._v("\n          Require password to view\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-form-input", {
                staticClass: "mt-2",
                attrs: {
                  state: _vm.passwordState,
                  disabled: !_vm.requirePassword,
                  placeholder: "New password",
                  type: "password",
                },
                model: {
                  value: _vm.password,
                  callback: function ($$v) {
                    _vm.password = $$v
                  },
                  expression: "password",
                },
              }),
              _vm._v(" "),
              _vm.catalogIsProtected && _vm.requirePassword && !_vm.password
                ? _c("small", { staticClass: "form-text text-muted" }, [
                    _vm._v(
                      "\n        Leave empty to keep the current password.\n      "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.requirePassword
                ? _c("b-form-invalid-feedback", [
                    _vm._v(
                      "\n        Password must be at least 4 characters.\n      "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("SelectFolderModal", {
        attrs: {
          mode: "select",
          "modal-id": "edit-catalog-logo-file-browser-modal",
          "modal-title": "Select logo",
        },
        on: { onSelectedItems: _vm.onSelectedItems },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }